<template>
  <footer class="footer">
    <div class="footer__top">
      <ul class="footer__list">
        <li class="footer__list--item" v-for="footerLink in $lang.footer.menu">
          <a v-bind:href="footerLink.link" class="footer__list--item-link">{{ footerLink.title }}</a>
        </li>
      </ul>
    </div>

    <div class="footer__bottom">
      <div class="footer__bottom--text">
        <p class="footer__bottom--img">
          <img src="static/img/footer__fbc.svg">
        </p>
        <p>
          <span class="footer__bottom--span">
            {{ $lang.footer.text.first }}
            <a v-bind:href="$lang.footer.text.PSNC.link" class="footer__bottom--link full">{{ $lang.footer.text.PSNC.full }}</a>
            <a v-bind:href="$lang.footer.text.PSNC.link" class="footer__bottom--link short">{{ $lang.footer.text.PSNC.short }}</a>
          </span>
          <span class="footer__bottom--span">
            {{ $lang.footer.text.second }}
            <a v-bind:href="$lang.footer.text.PIONIER.link" class="footer__bottom--link full">{{ $lang.footer.text.PIONIER.full }}</a>
            <a v-bind:href="$lang.footer.text.PIONIER.link" class="footer__bottom--link short">{{ $lang.footer.text.PIONIER.short }}</a>
          </span>
        </p>
        <p class="footer__bottom--partners">
          <a v-bind:href="$lang.footer.text.PSNC.link" target="_blank" class="footer__bottom--partners-link">
            <img src="static/img/footer__pcss.png" v-bind:title="$lang.footer.text.PSNC.full">
          </a>
          <a v-bind:href="$lang.footer.text.PIONIER.link" target="_blank" class="footer__bottom--partners-link">
            <img src="static/img/footer__pionier.png" v-bind:title="$lang.footer.text.PIONIER.full">
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'footer',
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// Footer.vue?547e161b